namespace TabAurous.HR {
    export interface LeavePolicyDetailsForm {
        LeaveTypeId: Serenity.IntegerEditor;
        AllocatedDays: Serenity.IntegerEditor;
    }

    export class LeavePolicyDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'HR.LeavePolicyDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LeavePolicyDetailsForm.init)  {
                LeavePolicyDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;

                Q.initFormType(LeavePolicyDetailsForm, [
                    'LeaveTypeId', w0,
                    'AllocatedDays', w0
                ]);
            }
        }
    }
}
